import { cssLengthToPx } from '../../../utils/proposalUnits';
import { parseMediaAspectRatioOption } from '../../../media/mediaFit';

/** Modes de taille du bloc « Contenu externe ». */
export const EMBED_SIZE_MODES = {
  auto: 'auto',
  ratio: 'ratio',
  height: 'height',
};

/** Repli quand ni le service ni l'utilisateur ne disent rien d'exploitable. */
const FALLBACK_SIZE = { kind: 'ratio', ratio: 16 / 9 };

/** Gabarit déclaré par le service (catalogue) → taille résolue. */
function serviceSize(defaultSize) {
  if (defaultSize?.mode === 'height' && defaultSize.heightPx > 0) {
    return { kind: 'height', heightPx: defaultSize.heightPx };
  }
  if (defaultSize?.mode === 'ratio' && defaultSize.ratio > 0) {
    return { kind: 'ratio', ratio: defaultSize.ratio };
  }
  return FALLBACK_SIZE;
}

/**
 * Taille effective de l'intégration. Le mode « auto » suit le gabarit du
 * service (Calendly se règle en hauteur, Figma en ratio) ; les deux autres
 * modes retombent dessus tant que leur valeur n'est pas exploitable — un champ
 * vidé ne doit pas écraser le bloc.
 * @returns {{kind: 'ratio', ratio: number}|{kind: 'height', heightPx: number}}
 */
export function resolveEmbedSize(props = {}, defaultSize = null) {
  const fromService = serviceSize(defaultSize);
  if (props.sizeMode === EMBED_SIZE_MODES.ratio) {
    const ratio = parseMediaAspectRatioOption(props.aspectRatio);
    return ratio ? { kind: 'ratio', ratio } : fromService;
  }
  if (props.sizeMode === EMBED_SIZE_MODES.height) {
    const heightPx = cssLengthToPx(props.height);
    return heightPx > 0 ? { kind: 'height', heightPx } : fromService;
  }
  return fromService;
}

/**
 * Boîte de l'intégration, en CSS. La MÊME fonction sert à la carte d'édition
 * et à l'iframe du site : c'est ce qui garantit que la page ne change pas de
 * longueur à la publication (chantier-embed.md §4.3).
 */
export function embedFrameStyle(size) {
  if (size?.kind === 'height') return { height: `${size.heightPx}px` };
  return { aspectRatio: String(size?.ratio ?? FALLBACK_SIZE.ratio) };
}
